// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MARfN","index":"styles_index__3WkfY"};